import {HttpErrorResponse} from '@angular/common/http';
import {appendAppLog} from '../services/app-log.service';

const AVG_RATE = 0.97;

const REFERENCE_DICT = {
  measurement_errors: {
    qnn_error: {
      raw: {
        // min: 0,
        // max: 0.01
      }
    }
  },
  secondary_aox: undefined,
  error_prediction: undefined
};

/**
 * if an error occurs, it is sent to this method
 * add the error to the error-array that is stored in the application storage (for more than just a session)
 * @param error error object
 */
export const logError = (error: any) => {
  if (!error) {
    return;
  }
  if (error.rejection) {
    error = error.rejection; // get the error object
  }
  let errorStack = '';
  try {
    errorStack = error.stack;
  } catch (e) {}
  appendAppLog({
    type: 'error',
    currentStage: 'ERROR',
    nextStage: 'ERROR',
    timestamp: Math.floor(Date.now() / 1000),
    msg: error?.message ?? String(error),
    errorName: error?.name,
    errorStack: errorStack ?? undefined,
  });
  console.error(error);
};


const mergeErrorsRec = (prev: object, current: object, ref: object) => {
  for (const [key, val] of Object.entries(current)) {
    if (typeof val === 'object' && !([null, undefined].includes(val))) {
      if (typeof prev[key] !== 'object') {
        prev[key] = {};
      }
      mergeErrorsRec(prev[key], val, ref[key] ?? {});
      continue;
    }
    if (val === null || val === undefined) {
      continue;
    }
    if (prev[key] === undefined || prev[key] === null || isNaN(prev[key])) {
      prev[key] = val;
      continue;
    }
    if (typeof prev[key] === 'number') {
      let newVal = val;
      if (ref[key] && typeof ref[key] === 'object' && typeof ref[key].min === 'number' && typeof ref[key].max === 'number') {
        newVal = Math.max(ref[key].min, Math.min(ref[key].max, newVal));
      }
      prev[key] = (prev[key] * AVG_RATE) + (newVal * (1 - AVG_RATE));
    }
  }
};

export const mergeErrors = (prev: any, current: any) => {
  const res = JSON.parse(JSON.stringify(prev));
  if (typeof (res?.measurement_errors) !== 'object') {
    res.measurement_errors = {};
  }
  if (typeof (res?.secondary_aox) !== 'object') {
    res.secondary_aox = {};
  }
  if (typeof (res?.error_prediction) !== 'object') {
    res.error_prediction = {};
  }
  mergeErrorsRec(res?.measurement_errors ?? {}, current?.measurement_errors ?? {}, REFERENCE_DICT?.measurement_errors ?? {});
  mergeErrorsRec(res?.secondary_aox ?? {}, current?.secondary_aox ?? {}, REFERENCE_DICT?.secondary_aox ?? {});
  mergeErrorsRec(res?.error_prediction ?? {}, current?.error_prediction ?? {}, REFERENCE_DICT?.error_prediction ?? {});
  for (const key of [
    'aox',
    'aox_q',
    'pressure',
    'veggie_result',
    'aox_decimal'
  ]) {
    const v1 = res[key];
    const v2 = current[key];
    if (typeof v1 !== 'number') {
      res[key] = v2;
      continue;
    }
    if (typeof v2 !== 'number') {
      continue;
    }

    let newVal = v2;
    if (
      REFERENCE_DICT[key]
      && typeof REFERENCE_DICT[key] === 'object'
      && typeof REFERENCE_DICT[key].min === 'number'
      && typeof REFERENCE_DICT[key].max === 'number'
    ) {
      newVal = Math.max(REFERENCE_DICT[key].min, Math.min(REFERENCE_DICT[key].max, newVal));
    }
    res[key] = (v1 * AVG_RATE) + (newVal * (1 - AVG_RATE));
  }
  return res;
};
